const productionConsole = {
  log: console.log, //if you want to use console.log in production, use productionConsole.log
}

if(process.env.NODE_ENV === "production") {
  console.log = () => {}; //clear console.log so we don't log unnecessary things to the console in production
}

export default productionConsole
